
import Cell from 'vux/src/components/cell/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
components: {
Group,
XInput,
XHeader,
XButton,
CellFormPreview,
Cell,
Previewer
},
directives: {
TransferDom
},
name: "orderDetail",
data() {
return {
options: {
getThumbBoundsFn(index) {

let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]

let pageYScroll = window.pageYOffset || document.documentElement.scrollTop


let rect = thumbnail.getBoundingClientRect()

return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}


}
},
value: "",
src:'',
list: [],
showTitle: false,
fdetailList: [],
header: {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
},
orderDetail: this.$route.params.order
};
},
methods: {
show(index) {
this.$refs.previewer.show(index)
},
getPhoto() {
return new Promise((resolve) => {
this.$http.get('/api/photos?path=' + this.orderDetail['detail']['bphoto'], this.header).then(response => {
resolve(response.data)
})
})
},
},
created() {
var orderDetail = this.$route.params.order;
switch (orderDetail["type"]) {
case "提现":
this.list = [
{
label: "交易单号",
value: orderDetail["seq"]
},
{
label: "类型",
value: "提现"
},
{
label: "提现金额",
value: orderDetail["detail"]["amount"]
},
{
label: "提现手续费",
value: orderDetail["detail"]["fee"]
}
];
var tmp = {};
if (orderDetail["detail"]["method"] === "WX") {
tmp = {label: "提现方式", value: "微信零钱"};
this.list.push(tmp);
} else if (orderDetail["detail"]["method"] === "BANK") {
tmp = {label: "提现方式", value: "银行"};
this.list.push(tmp);
tmp = {
label: "提现银行账户",
value: orderDetail["detail"]["baccount"]
};
this.list.push(tmp);
}
tmp = {label: "发起时间", value: orderDetail["start"]};
this.list.push(tmp);
if (orderDetail["state"] === "START") {
this.showTitle = false;
} else {
this.showTitle = true;
tmp = {label: "结束时间", value: orderDetail["end"]};
this.list.push(tmp);
tmp = {label: "交易状态", value: orderDetail["detail"]["state"]};
this.list.push(tmp);
if (orderDetail["state"] === "交易成功") {
this.value = (
parseFloat(orderDetail["amount"]) + parseFloat(orderDetail["fee"])
).toFixed(2);
} else {
this.value = 0.0;
}
}
break;
case "充值":
this.list = [
{
label: "交易单号",
value: orderDetail["seq"]
},
{
label: "类型",
value: "充值"
},
{
label: "充值金额",
value: orderDetail["detail"]["amount"]
}
];
if (orderDetail["detail"]["method"] === "WX") {
tmp = {label: "充值方式", value: "微信支付"};
this.list.push(tmp);
} else if (orderDetail["detail"]["method"] === "BANK") {
tmp = {label: "充值方式", value: "银行汇款"};
this.list.push(tmp);
}
tmp = {label: "发起时间", value: orderDetail["start"]};
this.list.push(tmp);
if (orderDetail["state"] === "START") {
this.showTitle = false;
} else {
this.showTitle = true;
tmp = {label: "结束时间", value: orderDetail["end"]};
this.list.push(tmp);
tmp = {label: "交易状态", value: orderDetail["state"]};
this.list.push(tmp);
if (orderDetail["state"] === "交易成功") {
this.value = orderDetail["detail"]["amount"];
} else {
this.value = "0.00";
}
}
if (
orderDetail["detail"]["instate"] === "ISSUE" ||
orderDetail["detail"]["instate"] === "ISSUEPRE"
) {
tmp = {label: "发票", value: "未开票"};
} else if (orderDetail["detail"]["instate"] === "NOISSUE") {
tmp = {label: "发票", value: "不需要开票"};
} else if (orderDetail["detail"]["instate"] === "FINISHED") {
tmp = {label: "发票", value: "已开具开票"};
}
this.list.push(tmp);
break;
case "奖励":
this.list = [
{
label: "交易单号",
value: orderDetail["seq"]
},
{
label: "类型",
value: "奖励"
},
{
label: "奖励金额",
value: orderDetail["detail"]["amount"]
}
];
if (orderDetail["detail"]["type"] === "EXPTREG") {
tmp = {label: "奖励类型", value: "专家注册成功奖励"};
} else if (orderDetail["detail"]["type"] === "RCMDEXPT") {
tmp = {label: "奖励类型", value: "推荐专家注册成功奖励"};
}
this.list.push(tmp);
tmp = {label: "发起时间", value: orderDetail["start"]};
this.list.push(tmp);
if (orderDetail["state"] === "START") {
this.showTitle = false;
} else {
this.showTitle = true;
tmp = {label: "结束时间", value: orderDetail["end"]};
this.list.push(tmp);
tmp = {label: "交易状态", value: orderDetail["state"]};
this.list.push(tmp);
if (orderDetail["state"] === "交易成功") {
this.value = orderDetail["detail"]["amount"];
} else {
this.value = "0.00";
}
}
break;
case '服务费':
this.list = [
{
label: "交易单号",
value: orderDetail["seq"]
},
{
label: "报修单号",
value: orderDetail["detail"]["order"]
},
{
label: "类型",
value: "服务费"
},
{
label: "服务费用",
value: orderDetail["detail"]["amount"]
}
];
this.list.push({label: "发起时间", value: orderDetail["start"]});
if (orderDetail["state"] === "START") {
this.showTitle = false;
} else {
this.showTitle = true;
tmp = {label: "结束时间", value: orderDetail["end"]};
this.list.push(tmp);
tmp = {label: "交易状态", value: orderDetail["state"]};
this.list.push(tmp);
if (orderDetail["state"] === "交易成功") {
this.value = orderDetail["detail"]["amount"];
} else {
this.value = "0.00";
}
}
break
case '维修费用支出':
if (orderDetail['detail']['bphoto']) {
this.getPhoto().then(response => {
this.fdetailList.push({src: 'data:image/jpeg;base64,' + response['value']})
this.src = 'data:image/jpeg;base64,' + response['value'];
})
}
this.list = [
{
label: "交易单号",
value: orderDetail["seq"]
},
{
label: "报修单号",
value: orderDetail["detail"]["gseq"]
},
{
label: "类型",
value: "维修费用支出"
},
{
label: "支出费用",
value: orderDetail["detail"]["amount"]
}
];
this.list.push({label: "发起时间", value: orderDetail["start"]});
if (orderDetail["state"] === "START") {
this.showTitle = false;
} else {
this.showTitle = true;
tmp = {label: "结束时间", value: orderDetail["end"]};
this.list.push(tmp);
tmp = {label: "交易状态", value: orderDetail["state"]};
this.list.push(tmp);
if (orderDetail["state"] === "交易成功") {
this.value = orderDetail["detail"]["amount"];
} else {
this.value = "0.00";
}
}
break
}
}
}



// WEBPACK FOOTER //
// ./src/components/orderDetail.vue